import {Component, Input} from '@angular/core';
import {AppGlobalEventManagerService} from '../../../services/app.globalEventManager.service';
import {environment} from '../../../../../environments/environment';
import { DestroyableComponent } from '../../../classes/destroyable.component';

@Component({
    selector: 'titleLayout',
    templateUrl: './title.layout.directive.html'
})
export class TitleLayoutDirective extends DestroyableComponent {

    @Input('title')title:string = '';
    public environment = environment;

    constructor(
      public appGlobalEventManagerService: AppGlobalEventManagerService
    ){
    super();

      this.subscribe(this.appGlobalEventManagerService.titleEmitter, (title) => {
        this.title = title;
      });

    }

}
